<template>
    <span>
        {{ startDate }}, {{ startTime }} <span v-if="end">- {{ endTime }}</span> {{ year }}
    </span>
</template>
<script setup>
import { computed } from 'vue';


const props = defineProps({
    start:{
        type:[String, Date],
        required:true
    },
    end:{
        type:[String, Date],
        required:false
    }
})

const startDate = computed(() => {
    let dateOptions = {
        month: 'long',
        day: 'numeric'
    };

    return new Intl.DateTimeFormat('en-US', dateOptions).format(new Date(props.start));
})

const startTime = computed(() => {
    let dateOptions = {
        hour:'numeric',
        minute:'numeric'
    };

    return new Intl.DateTimeFormat('en-US', dateOptions).format(new Date(props.start));
})

const endTime = computed(() => {
    let dateOptions = {
        hour:'numeric',
        minute:'numeric',
        timeZoneName:'short'
    };
    return new Intl.DateTimeFormat('en-US', dateOptions).format(new Date(props.end));
})

const year = computed(() => {
    let dateOptions = {
        year:'numeric'
    };
    if(props.end){
        return new Intl.DateTimeFormat('en-US', dateOptions).format(new Date(props.end));
    } else {
        return new Intl.DateTimeFormat('en-US', dateOptions).format(new Date(props.start));
    }
})
</script>
